/*
 * controllers/clubController.js
 * Club Controller
 */
define('app/controllers/clubController',[
    'app/ControllerClass',
    'app/models/clubModel',
    'app/views/clubView',
    'moment'], function(controllerClass, clubModel, clubView, moment) {
    return window.app.controllers.clubController = $.extend({}, controllerClass, {
        app: app,
        module: 'club',
        actions: {
            'show': ['indexAction'],
            'account': ['accountAction'],
            'statement': ['statementAction'],
            'clubGuestDirectory': ['clubGuestDirectoryAction']
        },
        init: function() {
            console.log('initializing club controller');
            app.data.messages = app.data.messages || [];
            this._init.call(this);
        },
        indexAction: function() {
            //making sure user is logged in
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile', 'login', ['next', 'membership']);
            } else {
                $.when(
                    clubModel.getData('fetchAccounts', {'CustomerId': app.data.CustomerId, 'CustomerGUID': app.data.CustomerGUID})
                    )
                    .done(function(userAccounts) {
                        var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
                        var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
                        // Dynamic restriction tryingToBook_module
                        app.commonViewHelper.eval_ttb({module:"clubBooking", vipLevel: vipLevels, membershipId:membershipIds});
                        if (userAccounts.Account.length == 1) {
                            //redirecting to show the account in details since user has only 1
                            app.dispatcher.redirect('membership', 'account', [userAccounts.Account[0].AccountId]);
                            return;
                        }

                    clubView.event.fire('indexAction', userAccounts);
                }).fail(function() {
                    app.data.messages.push({type: 'alert', 'class': 'alert-error', actions: [],
                        title: app.localization.club.fetchAccountsFail,
                        message: ''
                    });
                    app.dispatcher.replace('', '', []);
                });
            }
        },
        accountAction: function(accountId) {
            //making sure user is logged in
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile', 'login', ['next', 'membership', 'account', accountId]);
            } else {
                //user is logged in, preparing request params
                var accountsRequestParams = {
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID,
                };

                var clubBillingsRequestParams = $.extend({}, {AccountId: accountId}, accountsRequestParams);

                var clubStatementsRequestParams = $.extend({}, {BillDate: 'CURRENT'}, clubBillingsRequestParams);
                var nonClubBookingsInCart = false
                var dfd = $.Deferred()
                if(app.customization.club.clubPaymentsEnabled){
                    $.when(
                        app.models.systemModel.getData('folioBookings', {}))
                        .always(function (r_fb) {
                            if (r_fb.WebFolioItem) {
                                _.each(r_fb.WebFolioItem, function (folio) {
                                    if (folio.Category == 'Club') {
                                        app.models.clubModel.getData('cancelClubPayment', {
                                            ClubAccount: folio.FolioId,
                                            ItemId: folio.FolioItemId
                                        }).then(function (r) {
                                            app.models.systemModel.getData('folioBalance', {}) //update cart total to reflect it on navbar
                                            app.datal("clubBookingInCart",false)
                                            dfd.resolve()
                                        }).fail(function(){
                                            dfd.resolve()
                                        })
                                    } else  {
                                        nonClubBookingsInCart = true
                                        dfd.resolve()
                                    }
                                })
                            } else dfd.resolve()
                        })
                } else dfd.resolve()
                $.when.call(this, dfd.promise()).then(function (e) {
                    $.when( clubModel.getData('fetchAccounts', accountsRequestParams),
                            clubModel.getData('fetchClubBillings', clubBillingsRequestParams),
                            clubModel.getData('fetchClubStatement', clubStatementsRequestParams)
                            )
                            .done(function(accountsResponse, clubBillingsResponse, clubStatementsResponse) {

                        //passing only current account details to the view
                        for (var currentAccountIndex = 0; currentAccountIndex < accountsResponse.Account.length; currentAccountIndex++) {
                            if (accountId == accountsResponse.Account[currentAccountIndex].AccountId) {
                                break;
                            }
                        }
                        clubStatementsResponse._current = true;                    

                        // We commented out these two line cause we don't want to make calls each time
                        // app.models.clubModel.dataModel.fetchClubStatement.data =  {}; // to refetch new data
                        // app.models.clubModel.dataModel.fetchClubBillings.data = {} // to refetch new data.
                    
                        // try {
                        //     app.models.clubModel.dataModel.fetchClubStatement.data[
                        //         app.models.clubModel.makeStandardName(
                        //             app.models.clubModel.dataModel.fetchClubStatement,
                        //             $.extend(clubBillingsRequestParams,{BillDate:clubStatementsResponse.Account[0].BillingPeriods.BillingPeriod.BillDate})
                        //         )
                        //     ] = clubStatementsResponse;
                        // } catch (e) {

                        // }
                        // try { // fetching clubBilling again
                        //     app.models.clubModel.dataModel.fetchClubStatement.data[
                        //         app.models.clubModel.makeStandardName(
                        //             app.models.clubModel.dataModel.fetchClubBillings,
                        //             clubBillingsRequestParams)
                                
                        //     ] = clubBillingsResponse;
                        // } catch (e) {

                        // }

                        clubView.event.fire('accountAction', {
                            accountResponse: accountsResponse.Account[currentAccountIndex],
                            clubBillingsResponse: clubBillingsResponse,
                            clubStatementsResponse: clubStatementsResponse,
                            nonClubBookingsInCart:nonClubBookingsInCart
                        });                        
                    
                    }).fail(function() {
                        app.data.messages.push({type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.club.fetchStatementsFail,
                            message: ''
                        });
                        app.dispatcher.replace('', '', []);
                    });
                })
            }
        },
        statementAction: function(accountId, billDate, hasStatementAccess, isCurrentPeriod) {
            var soapRequestParams = {
                CustomerId: app.data.CustomerId,
                CustomerGUID: app.data.CustomerGUID,
                BillDate: isCurrentPeriod ? 'CURRENT' : billDate,
                AccountId: accountId
            };
            //THis call only when statementAccess = 'Y' extra validation
            if(hasStatementAccess) {
                $.when(clubModel.getData('fetchClubStatement', soapRequestParams))
                        .done(function(statementsResponse) {
                    clubView.event.fire('statementAction', {
                        billDate: billDate,
                        statementsResponse: statementsResponse
                    });
                }).fail(function() {
                    clubView.event.fire('statementAction', {billDate: billDate,error: true});
                });
            }
        },
        clubGuestDirectoryAction: function(accountId){
            //making sure user is logged in
            if (!app.data.userLoggedIn) {
                app.dispatcher.redirect('profile', 'login', ['next', 'membership']);
            } else {
                var accountsRequestParams = {
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID,
                };

                $.when( app.models.clubModel.getData('fetchAccounts', accountsRequestParams))
                    .always(function(accountResponse){
                        var directoryAccount = _.filter(accountResponse.Account, function(item){ return item.AccountId == accountId})[0];
                        if (['O', 'F'].indexOf(directoryAccount.MemberDirectory) > -1) {
                            $('#progressIndicator').modal({
                                backdrop:'static',
                                show:true,
                                keyboard:false
                            });
                            //fetch membor directoy
                            app.models.clubModel.getData('FetchClubDirectoryRequest', {
                                CustomerId: app.data.CustomerId,
                                CustomerGUID: app.data.CustomerGUID,
                                AccountId: accountId
                            })
                            .done(function (r_fcp) {
                                var memberList = $.wrapArray(r_fcp.Members[0].Member);
                                var memberList = memberList.map(function (val) {
                                    var obj = {
                                        name: val.Salutation + ' ' + val.FirstName + ' ' + val.LastName,
                                        address: val.Address + ',' + val.City + ',' + val.StateProv + ',' + val.PostalCode,
                                        VIPLevel: val.VIPLevel,
                                        phone: val.PhoneNumber + (val.PhoneExt ? " Ext: " + val.PhoneExt : ''),
                                        email: val.EmailAddress,
                                        Gender: val.Gender,
                                        Birthdate:val.Birthdate,
                                        GolfPlayerType:val.GolfPlayerType,
                                        
                                    }
                                    return obj
                                })
                                clubView.event.fire('clubGuestDirectory', {
                                    accountId: accountId,
                                    memberList: memberList
                                });
                            })
        
                        } else {
                            app.data.messages.push({
                                type: 'alert',
                                'class': 'alert-error',
                                actions: [],
                                title: app.localization.club.noGuestDirectoryAccess,
                                message: ''
                            });
                            // changed this to fix breaking code- accounts without access go back
                            app.dispatcher.replace('membership', 'account', [accountId]);
                        }
                    })

            }
        }
    });
});

